const convertDateToString = ({ lang, dates }) => {
    const dateNum = new Date(dates)
    const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }
    const locale = lang === 'es' ? 'es-ES' : 'eu-EU'

    return dateNum.toLocaleDateString(locale, options)
}

export default convertDateToString